'use client';

import { useEffect, useState } from 'react';
import { useClerk } from '@clerk/nextjs';
import { clearClerkClientCache } from '@/app/utils/clerkCache';

function readCookie(name: string) {
  return document.cookie
    .split(';')
    .map((cookie) => cookie.trim())
    .find((cookie) => cookie.startsWith(`${name}=`))
    ?.split('=')
    .slice(1)
    .join('=');
}

export default function ImpersonationBanner() {
  const [isActive, setIsActive] = useState(false);
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const clerk = useClerk();

  useEffect(() => {
    const active = readCookie('impersonation_active');
    if (active) {
      setIsActive(true);
      const storedEmail = readCookie('impersonation_user_email');
      if (storedEmail) {
        setEmail(decodeURIComponent(storedEmail));
      }
    }
  }, []);

  const handleStop = async () => {
    setLoading(true);
    try {
      const response = await fetch('/api/org/impersonate/exit', {
        method: 'POST',
        credentials: 'include',
      });
      if (!response.ok) {
        throw new Error('Unable to stop impersonation');
      }
      clearClerkClientCache();
      await clerk?.session?.reload();
      await clerk?.user?.reload();
      window.location.reload();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  if (!isActive) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 20,
        left: 20,
        zIndex: 50,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 6,
        color: '#f8fafc',
      }}
    >
      <button
        type='button'
        onClick={handleStop}
        disabled={loading}
        style={{
          background: '#f97316',
          border: 'none',
          borderRadius: 999,
          padding: '8px 16px',
          color: '#0f172a',
          fontWeight: 600,
          cursor: 'pointer',
          fontSize: 13,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          whiteSpace: 'nowrap',
          boxShadow: '0 6px 16px rgba(0,0,0,0.4)',
        }}
      >
        {loading ? 'Stopping…' : 'Stop impersonation'}
      </button>
      <span style={{ fontSize: 12, color: '#cad4ff' }}>
        Impersonating {email || 'another user'}
      </span>
    </div>
  );
}
